import React, { useState, ChangeEvent, FC, useEffect } from 'react';

interface EngineSpeedCANProps {
  alarm: any;
  onChange: (newMetrics: any) => void;
}

const EngineSpeedCAN: FC<EngineSpeedCANProps> = ({ alarm, onChange }) => {
  const [rpmThreshold, setRpmThreshold] = useState<number>(0);

  useEffect(() => {
    if (alarm !== "") {
      setRpmThreshold(alarm.rpm_threshold);
    } else {
      setRpmThreshold(0);
    }
  }, [alarm]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    setRpmThreshold(value);
    onChange({ type: "EngineSpeedCAN", rpm_threshold: value });
  };

  return (
    <div className="input-group col-md-4 col-sm-4">
      <input
        className="form-control input-sm"
        name="engine_speed_can"
        value={rpmThreshold}
        placeholder="Engine RPM Threshold"
        type="number"
        size={10}
        maxLength={20}
        onChange={handleInputChange}
      />
      <span style={{ paddingLeft: 10 }} className="input-group-addon">RPM</span>
    </div>
  );
};

export default EngineSpeedCAN;
